export const actionsReducer = (state:[], action:any) => {
    switch (action.type) {
        case 'SET_ACTIONS':
            state = action.payload;
            return state;
        default:
            return state || [];
    }
}